import { lazy } from "react";

import { app } from "~/helpers/routes";
import { DISABLE_PAYMENTS } from "~/helpers/plans";
import { paths } from "~/router/paths";
import PlansSettingsPage from "~/pages/settings/plans";

const AccountSettingsPage = lazy(() => import("~/pages/settings/account"));
const MobileTabs = lazy(() => import("~/pages/settings/mobile-tabs"));
const MembershipSettingsPage = lazy(
  () => import("~/pages/settings/membership")
);
const PricingRulesSettingsPage = lazy(
  () => import("~/pages/settings/pricing-rules")
);

const isMobile = window?.innerWidth <= 440;

export const routes: Array<any> = [
  {
    path: paths.settings.account,
    element: isMobile ? app(MobileTabs) : app(AccountSettingsPage),
  },
  ...(DISABLE_PAYMENTS
    ? []
    : [
        {
          path: paths.settings.plans,
          element: isMobile ? app(MobileTabs) : app(PlansSettingsPage),
        },
      ]),
  {
    path: paths.settings.membership,
    element: isMobile ? app(MobileTabs) : app(MembershipSettingsPage),
  },
  {
    path: paths.settings.pricingRules,
    element: isMobile ? app(MobileTabs) : app(PricingRulesSettingsPage),
  },
];
